import type { PropsWithChildren } from "react"
import React, { useEffect, useState } from "react"
import { AnimatePresence, motion, MotionConfig } from "motion/react"
import { useMeasure } from "react-use"

import { easeInOut } from "@productlane/ui/src/helpers/animations"

const transition = { type: "tween" as const, ease: easeInOut, duration: 0.2 }

interface Props {
	className?: string
	initial?: boolean
}

export const ResizablePanel = React.memo(
	({ children }: PropsWithChildren<Props>) => {
		const [ref, bounds] = useMeasure<HTMLDivElement>()
		const [prevHeight, setPrevHeight] = useState(bounds.height)
		useEffect(() => {
			if (prevHeight !== bounds.height) {
				setPrevHeight(bounds.height)
			}
		}, [bounds.height, prevHeight])

		return (
			<MotionConfig transition={transition}>
				<motion.div
					// @ts-expect-error type issue
					animate={{ height: bounds.height > 0 ? bounds.height : null }}
					transition={{ ease: easeInOut, duration: 0.4 }}
					// animate={{
					// 	height,
					// 	transition: {
					// 		height: {
					// 			duration: prevHeight === 0 && initial === false ? 0 : 0.3,
					// 			type: "spring",
					// 		},
					// 	},
					// }}
					// initial={initial}
					className="relative overflow-hidden"
				>
					<div
						ref={ref}
						// className={cn(
						// 	`${height ? "relative" : "absolute"}`,
						// 	"w-full",
						// 	className,
						// )}
					>
						<AnimatePresence mode="popLayout" initial={false}>
							<motion.div
								key={JSON.stringify(children, ignoreCircularReferences())}
								initial={{
									opacity: 0,
								}}
								animate={{
									opacity: 1,
									transition: {
										...transition,
										duration: transition.duration / 2,
										delay: transition.duration / 2,
									},
								}}
								exit={{
									opacity: 0,
									transition: {
										...transition,
										duration: transition.duration / 2,
									},
								}}
							>
								{children}
							</motion.div>
						</AnimatePresence>
					</div>
				</motion.div>
			</MotionConfig>
		)
	},
)

/*
  Replacer function to JSON.stringify that ignores
  circular references and internal React properties.
  https://github.com/facebook/react/issues/8669#issuecomment-531515508
*/
const ignoreCircularReferences = () => {
	const seen = new WeakSet()
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (key: any, value: any) => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
		if (key.startsWith("_")) return // Don't compare React's internal props.
		if (typeof value === "object" && value !== null) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
			if (seen.has(value)) return
			// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
			seen.add(value)
		}
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return value
	}
}
